




































import {
  ActualiteDTO,
  FilterDTO,
  GraeDTO,
  PaginationParameter,
  UtilisateurDTO,
} from "@/model/bean/GeneratedDTOs"
import { Component, Vue } from "vue-property-decorator"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import { OrganismeService } from "@/services/rest/organisme/OrganismeService"
import { UsersService } from "@/services/rest/users/UsersService"
import { ActualiteService } from "@/services/rest/actualite/ActualiteService"
import ConversionUtils from "@/services/ConversionUtils"
import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import { LoginService } from "@/services/rest/login/LoginService"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import ContactCardsView from "@/views/commons/ContactCardsView.vue"
import ActualitesView from "@/views/grae/ActualitesView.vue"
import ActualitesCardsView from "@/pages/actualite/ActualitesCardsView.vue"
import { Filters } from "@/model/bean/Filters"
import SubHeaderItem from "@/views/commons/SubHeaderItem.vue"

@Component({
  components: {
    SubHeaderItem,
    ActualitesCardsView,
    ActualitesView,
    ContactCardsView,
    PageView,
    ContentView,
    H3TitleView,
  },
})
export default class ActualitePage extends Vue {
  private loginService = LoginService.INSTANCE
  private infoReportingService = InfoReportingService.INSTANCE
  private organismeService = OrganismeService.INSTANCE
  private usersService = UsersService.INSTANCE
  private actualiteService = ActualiteService.INSTANCE

  loggedUser: UtilisateurDTO = new UtilisateurDTO()
  isLoadingData = true

  grae = new GraeDTO()
  contact = new UtilisateurDTO()
  actualitesNat: ActualiteDTO[] = []
  actualitesReg: ActualiteDTO[] = []

  created(): void {
    const loggedUser = this.loginService.getLoggedUser()
    if (!loggedUser) {
      return
    }
    this.loggedUser = loggedUser
    this.init()
  }

  async init(): Promise<void> {
    this.isLoadingData = true

    await this.setGrae()
    await this.setContact()
    await this.setActualites()

    this.isLoadingData = false
  }

  async setGrae(): Promise<void> {
    if (this.loggedUser && this.loggedUser.grae && this.loggedUser.grae.id) {
      this.grae = await this.organismeService.getGrae(this.loggedUser.grae.id)
    }
  }

  async setContact(): Promise<void> {
    if (this.grae?.contactId) {
      try {
        this.contact = await this.usersService.getUserProfile(this.grae.contactId)
      } catch (e) {
        this.infoReportingService.error("Erreur rencontrée sur le contact", e as Error)
      }
    }
  }

  async setActualites(): Promise<void> {
    const paginationParameter = new PaginationParameter()
    paginationParameter.pageNumber = 1
    paginationParameter.pageSize = 9999

    const filters = new Array<FilterDTO>()
    const today = ConversionUtils.convertToUTCDate(new Date()).toISOString().substring(0, 10)
    const publishedAtFilter = Filters.asFilter({ property: "is-published-at", values: [today] })
    filters.push(publishedAtFilter)

    try {
      const paginatedResponse = await this.actualiteService.getAllActualitesForGRAE(
        this.grae?.id,
        paginationParameter,
        filters
      )

      if (paginatedResponse.elements.length > 0) {
        const { withGraeId, withoutGraeId } = paginatedResponse.elements.reduce(
          (acc, actu: ActualiteDTO) => {
            if (!actu.grae) {
              acc.withoutGraeId.push(actu)
            } else {
              acc.withGraeId.push(actu)
            }
            return acc
          },
          { withGraeId: [] as ActualiteDTO[], withoutGraeId: [] as ActualiteDTO[] }
        )

        this.actualitesNat = withoutGraeId
        this.actualitesReg = withGraeId
      }
    } catch (e) {
      this.infoReportingService.error(
        this.$t("projet.en-bref.error-actualites").toString(),
        e as Error
      )
    }
  }
}
